module.exports = __webpack_public_path__ + "img/wx3.5ab44af1.jpg";